import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import BackgroundOfElderlyForm from './BackgroundOfElderlyForm'
import BackgroundOfElderlyView from './BackgroundOfElderlyView'
import { useForm, Controller } from 'react-hook-form'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { startLoading, doneLoading } from '../../../../utils/loading'
import { getSchemaSidebar } from '../../../../redux/actions/sidebar'
import { updateForm5, saveForm5 } from '../../../../redux/actions/background'
import ButtonPanel from '../../../ButtonPanel'
import WhisperMoreContent from '../../../WhisperMoreContent'
import WarningMessage from '../../../../components/message/WarningMessage/WarningMessage'

export default function BackgroundOfElderlyWidget(props) {
  const { showCommandButton, schema, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [formSchema, setFormSchema] = useState(schema)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [moreContent, setMoreContent] = useState(true)
  const [moreContentBottom, setMoreContentBottom] = useState(true)

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response
      if (request.id) {
        console.log('call update.')
        response = await updateForm5(projectId, request)
      } else {
        console.log('call save.')
        response = await saveForm5(projectId, request)
      }
      console.log('response', response)
      if (response) {
        onChangeIsEdit(false)
        setFormSchema(response)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    const request = {
      id: formSchema.id,
      projectVersionId: projectId,
      activity: data.activity,
      activityYear: data.activityYear,
      activityMember: data.activityMember,
      activityLeader: data.activityLeader,
      activityList: data.activityList,
      activityProblem: data.activityProblem,
      allPeople: data.allPeople || 0,
      elderlyPeople: data.elderlyPeople || 0,
      elderlySocialGroup: data.elderlySocialGroup || 0,
      elderlyHomeGroup: data.elderlyHomeGroup || 0,
      elderlyBedStickGroup: data.elderlyBedStickGroup || 0,
      elderlyTypeSourceInfo: data.elderlyTypeSourceInfo || '',
      elderlyTypeSourceMonth: data.elderlyTypeSourceMonth || 0,
      elderlyTypeSourceInfoYear: data.elderlyTypeSourceInfoYear || 0,
      elderlyNoHealthProblem: data.elderlyNoHealthProblem || 0,
      elderlyHealthProblem: data.elderlyHealthProblem || 0,
      elderlyHypertension: data.elderlyHypertension || 0,
      elderlyDiabetes: data.elderlyDiabetes || 0,
      elderlyDegenerative: data.elderlyDegenerative || 0,
      elderlyEmphysema: data.elderlyEmphysema || 0,
      elderlyCoronaryHeartDisease: data.elderlyCoronaryHeartDisease || 0,
      elderlyParalysis: data.elderlyParalysis || 0,
      elderlyDepression: data.elderlyDepression || 0,
      otherDisease: data.elderlyOtherDisease,
      elderlyHealthPromotion: data.elderlyHealthPromotion || 0,
      elderlyHealthExercise: data.elderlyHealthExercise || 0,
      elderlyHealthRightFood: data.elderlyHealthRightFood || 0,
      elderlyHealthSourceInfo: data.elderlyHealthSourceInfo || '',
      elderlyHealthSourceMonth: data.elderlyHealthSourceMonth || 0,
      elderlyHealthSourceInfoYear: data.elderlyHealthSourceInfoYear || 0,
      elderlySocialCount: data.elderlySocialCount || 0,
      elderlySocialJoinActivity: data.elderlySocialJoinActivity || 0,
      elderlySocialAccident: data.elderlySocialAccident || 0,
      elderlySocialInfoSummaray: data.elderlySocialInfoSummaray || 0,
      elderlySocialInfoPercent: data.elderlySocialInfoPercent || 0,
      elderlySocialInfoFooter: data.elderlySocialInfoFooter || '',
      otherProblems: data.otherProblems,
    }

    console.log('request', JSON.stringify(request))
    handleCallService(request)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

      {moreContent && (
        <>
          <div dangerouslySetInnerHTML={{ __html: formSchema.introduction }} />
        </>
      )}

      {formSchema.introduction && (
        <div style={{ textAlign: 'center', marginTop: 10 }}>
          <WhisperMoreContent
            isShow={moreContent}
            onClick={() => {
              setMoreContent(!moreContent)
            }}
          />
        </div>
      )}

      {isEdit && showCommandButton ? (
        <BackgroundOfElderlyForm
          schema={formSchema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          getValues={getValues}
        />
      ) : (
        // <label> DEV... </label>
        <BackgroundOfElderlyView schema={formSchema} />
      )}

      <div style={{ textAlign: 'center' }}>
        <WhisperMoreContent
          isShow={moreContentBottom}
          onClick={() => {
            setMoreContentBottom(!moreContentBottom)
          }}
        />
      </div>

      {moreContentBottom && <div dangerouslySetInnerHTML={{ __html: formSchema.footer }} />}

      {showCommandButton && (
        <>
          <hr />
          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={formSchema.buttonText || 'ความเป็นมาหลักการและเหตุผล'}
            onSave={handleSubmit(onSubmit)}
            onCancel={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
            }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </>
      )}
    </Panel>
  )
}

// const formSchemas = {
//   header:
//     'ความเป็นมา / หลักการและเหตุผล / ความสำคัญของปัญหา (05 สร้างเสริมสุขภาพผู้สูงอายุ ปี 63)',
//   introduction: `<p>
//     &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ประเทศไทยจะเป็นสังคมผู้สูงอายุโดยสมบูรณ์
//     (Complete Aged Society) ในปี พ.ศ. 2564 หรือ อีก 3 ปีข้างหน้า ประชากรสูงอายุจะมีถึง 1
//     ใน 5 ทั้งนี้ในปี 2562 จะเป็นครั้งแรกที่ประเทศไทยมีประชากรสูงอายุมากกว่าประชากรวัยเด็ก
//     และจะเป็น “สังคมสูงวัยระดับสุดยอด” (Super Aged Society) ในอีกไม่ถึง 20 ปี (พ.ศ 2578)
//     ซึ่งโครงสร้างอายุของประชากรที่เปลี่ยนไปนี้เท่ากับเป็นการเปลี่ยนโครงสร้างของสังคมโดยรวมด้วย
//     และในปัจจุบันผู้สูงอายุส่วนใหญ่ประมาณร้อยละ 96.9 ของจำนวนผู้สูงอายุทั้งหมดคือ
//     ผู้สูงอายุที่สามารถดูแลตัวเองได้โดยไม่ต้องพึ่งผู้อื่น (กลุ่มติดสังคม)
//     โดยส่วนใหญ่อยู่ในช่วงอายุ 60-69 ปี อีกร้อยละ 2
//     เป็นผู้สูงอายุที่ต้องพึ่งผู้อื่นในบางกิจกรรมของกิจกรรมของกิจวัตรประจำวัน
//     (กลุ่มติดบ้าน) และผู้สูงอายุที่ต้องพึ่งพาผู้อื่นทั้งหมดร้อยละ 1.1
//     โดยส่วนใหญ่อยู่ในวัยมากกว่า 80 ปี ซึ่งผู้สูงอายุในช่วยวัยปลายหรืออายุตั้งแต่ 80
//     ปีขึ้นไปนั้น มีแนวโน้มเพิ่มขึ้น
//     จึงน่าจะสะท้อนถึงการเพิ่มขึ้นของประชากรที่อยู่ในวัยพึ่งพิงทั้งในเชิงเศรษฐกิจ
//     สังคมและสุขภาพ
//   </p>
//   <p>
//     &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; แม้ว่าประชากรไทยจะมีอายุยืนยาวขึ้น
//     แต่กลับตามมาด้วยการเจ็บป่วยด้วยโรคเรื้อรังยาวนานขึ้น
//     และโอกาสที่จะอยู่ในภาวะพึ่งพิงเนื่องมาจากการมีทุพพลภาพและผู้สูงอายุที่อยู่ลำพังมีแนวโน้มเพิ่มขึ้น
//     ทั้งนี้ปัญหาสำคัญของผู้สูงอายุ คือ ประเด็นสุขภาพและด้านเศรษฐกิจ
//     ซึ่งในด้านสุขภาพจากผลการสำรวจสุขภาวะผู้สูงอายุไทยปี 2556 พบว่าผู้สูงอายุร้อยละ 95
//     มีปัญหาสุขภาพด้วยโรคเรื้อรังต่างๆ ได้แก่ โรคความดันโลหิตสูง โรคเบาหวาน โรคข้ออักเสบ
//     ข้อเสื่อม โรคถุงลมโป่งพอง โรคหลอดเลือดหัวใจตีบ กล้ามเนื้อหัวใจตายและอัมพาต
//     รวมทั้งยังมีภาวะซึมเศร้าในผู้สูงอายุด้วย
//     นอกจากนี้ยังมีข้อมูลว่ามีผู้สูงอายุเพียงร้อยละ 26.5 มีการออกกำลังกายเป็นประจำ
//     ดังนั้นหากปล่อยให้เป็นเช่นนี้จะส่งผลกระทบต่อทั้งตัวผู้สูงอายุเอง ครอบครัว
//     รวมถึงภาครัฐที่จะต้องใช้งบประมาณจำนวนมหาศาลเพื่อเป็นค่าใช้จ่ายในการดูแลรักษาสุขภาพ
//     ดังนั้น
//     จึงจำเป็นที่จะต้องมีการเฝ้าระวังดูแลสุขภาพอย่างต่อเนื่องตลอดจนการปรับพฤติกรรมสุขภาพให้เหมาะสม
//     ในด้านสังคม พบว่า ในปี 2560
//     มีผู้สูงอายุที่เข้าร่วมกิจกรรมกลุ่ม/ชมรมผู้สูงอายุเพียงร้อยละ 33.7
//     ส่วนด้านสภาพแวดล้อมที่เอื้อต่อการดำเนินชีวิต พบว่า ผู้สูงอายุกว่าร้อยละ 10
//     เคยมีประสบการณ์ในการหกล้ม ดังนั้นจึงจำเป็นต้องจัดให้มีสิ่งอำนวยความสะดวกภายในบ้าน เช่น
//     ราวจับ
//     และการปรับสภาพพื้นที่ในบ้านและนอกบ้านให้เอื้อต่อการใช้ชีวิตอย่างปลอดภัยและป้องกันการหกล้ม
//     ซึ่งเป็นสาเหตุของการบาดเจ็บอันนำไปสู่ภาวะติดบ้านและติดเตียงตามมา ในด้านเศรษฐกิจ พบว่า
//     ผู้สูงอายุร้อยละ 34.3 เป็นผู้สูงอายุที่ยากจน
//     โดยการทำงานส่วนใหญ่อยู่ในภาคเกษตรกรรมร้อยละ 58.8 รองลงมาคือการค้าและบริการร้อยละ 30.4
//   </p>
//   <p>
//     &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ดังนั้น
//     เพื่อรองรับสังคมสูงอายุและพัฒนาคุณภาพชีวิตผู้สูงอายุ
//     กลุ่มหรือชมรมผู้สูงอายุในระดับหมู่บ้านหรือชุมชนถือเป็นกลไกสำคัญที่มีบทบาทสนับสนุนการสร้างเสริมสุขภาพและพัฒนาคุณภาพชีวิตให้แก่ผู้สูงอายุ
//     เนื่องจากมีความใกล้ชิด เข้าใจสภาพปัญหาและความต้องการของผู้สูงอายุ
//     รวมถึงสามารถเข้าถึงและพัฒนาผู้สูงอายุในชุมชนได้ดีที่สุด
//     แต่ในปัจจุบันกลับพบว่ากลุ่มหรือชมรมผู้สูงอายุในบางพื้นที่ยังขาดความเข้มแข็งในการดำเนินงานเพื่อสร้างเสริมสุขภาพผู้สูงอายุทั้งด้านร่างกาย
//     จิตใจและสังคม กล่าวคือ บางกลุ่มเพิ่งอยู่ในระยะเริ่มต้นของการรวมตัว
//     หรือบางกลุ่มแม้จะมีการรวมตัวมานานแล้วแต่ขาดการดำเนินกิจกรรมอย่างต่อเนื่องให้แก่ผู้สูงอายุในชุมชน
//   </p>

//   <p>
//     &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;สำหรับในปัจจุบันบ้าน <b>เวียงหมอก</b> ตำบล
//     <b>ห้วยซ้อ</b> อำเภอ <b>เชียงของ</b> จังหวัด <b>เชียงราย</b> พบว่า
//     <b>ได้มีกลุ่มหรือชมรมผู้สูงอายุระดับหมู่บ้าน</b> บ้าน <b>เวียงหมอก</b>
//     ซึ่งเป็นชมรมที่จัดตั้งขึ้นตั้งแต่ พ.ศ.<b>2560</b> และในปัจจุบันมีสมาชิกจำนวน
//     <b>746</b> คน โดยมี <b>วัลลภ บุญประเสริฐ</b> เป็นประธานชมรมผู้สูงอายุ
//   </p>
//   <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;โดยมีกิจกรรมเกี่ยวกับผู้สูงอายุที่ได้เคยดำเนินงานมาแล้วดังนี้</p>`,
//   footer: `<p>
//   &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;ทั้งนี้จากข้อมูลสถานการณ์ดังกล่าวข้างต้น ทางกลุ่มหรือชมรมผู้สูงอายุบ้าน
//   <b>
//     เวียงหมอก
//   </b>
//   ได้เล็งเห็นถึงความสำคัญของการสร้างเสริมสุขภาพของผู้สูงอายุทั้งด้านร่างกาย
//   จิตใจและสังคม โดยกลุ่มหรือชมรมผู้สูงอายุบ้าน
//   <b>
//     เวียงหมอก
//   </b>
//   จะเป็นกลไกสำคัญในการดำเนินงาน ด้วยเหตุนี้ จึงสมัครเข้าร่วมโครงการ
//   “สร้างเสริมสุขภาพผู้สูงอายุในชุมชน” กับ สสส.
//   เพื่อให้ผู้สูงอายุในชุมชนมีพฤติกรรมการดูแลสุขภาพได้อย่างถูกต้องและเหมาะสมกับวัย
// </p>`,
//   villageInfo: {
//     village: 'เวียงหมอก',
//     subDistrict: 'ห้วยซ้อ',
//     district: 'เชียงของ',
//     province: 'เชียงราย',
//   },
//   activity: {
//     name: 'activity',
//     label:
//       'สำหรับในปัจจุบันบ้าน {village} ตำบล {subDistrict} อำเภอ {district} จังหวัด {province} พบว่า',
//     value: '',
//     options: [
//       { value: 'N', label: 'ยังไม่มีการรวมกลุ่มหรือชมรมผู้สูงอายุระดับหมู่บ้าน' },
//       { value: 'Y', label: 'ได้มีกลุ่มหรือชมรมผู้สูงอายุระดับหมู่บ้าน' },
//     ],
//   },
//   activityYear: {
//     name: 'activityYear',
//     label: 'ซึ่งเป็นชมรมที่จัดตั้งขึ้นตั้งแต่ พ.ศ.',
//     value: '',
//     validators: [
//       {
//         type: 'MAXLENGTH',
//         value: 4,
//         errorMessage: 'กรอกได้ไม่เกิด 4 ตัว',
//       },
//     ],
//   },
//   activityMember: {
//     name: 'activityMember',
//     preLabel: 'และในปัจจุบันมีสมาชิกจำนวน ',
//     postLabel: ' คน',
//     value: '',
//   },
//   activityLeader: {
//     name: 'activityLeader',
//     preLabel: ' โดยมี ',
//     postLabel: ' เป็นประธานชมรมผู้สูงอายุ ',
//     value: '',
//   },
//   activityList: {
//     name: 'activityList',
//     label: 'โดยมีกิจกรรมเกี่ยวกับผู้สูงอายุที่ได้เคยดำเนินงานมาแล้วดังนี้',
//     description: [
//       'ให้อธิบายข้อมูลกิจกรรมที่เคยดำเนินงานของกลุ่มหรือชมรมผู้สูงอายุที่ผ่านมา และผลที่เกิดขึ้นโดยละเอียด ไม่ควรบอกเพียงหัวข้อสั้นๆ กรณีมีหลายข้อให้ทำการขึ้นบรรทัดหรือย่อหน้าใหม่',
//     ],
//     value: [
//       { activity: 'XXX', result: 'SSSSSSSSSSSSSSSSSSSSS' },
//       { activity: 'YYY', result: '' },
//     ],
//   },
//   activityForm: {
//     activity: {
//       name: 'activity',
//       label: 'กิจกรรมที่',
//       hint: 'ชื่อกิจกรรม',
//     },
//     result: {
//       name: 'result',
//       label: 'ผลที่เกิดขึ้น',
//       hint: 'ผลที่เกิดขึ้นจากการทำกิจกรรม',
//     },
//   },
//   activityProblem: {
//     name: 'activityProblem',
//     label:
//       'ซึ่งจากการดำเนินงานที่ผ่านมาพบว่า ยังมีปัญหาอุปสรรคและต้องการการพัฒนาเพื่อเสริมสร้างความเข้มแข็งให้แก่กลุ่มหรือหรือชมรมผู้สูงอายุในเรื่องดังต่อไปนี้',
//     description: [
//       '1.ให้อธิบายข้อมูลปัญหาอุปสรรคและสิ่งที่ต้องการเสริมสร้างความเข้มแข็งให้แก่กลุ่มหรือชมรมผู้อายุโดยละเอียดไม่ควรบอกเพียงหัวข้อสั้นๆ',
//       '2. ควรวิเคราะห์ให้ครอบคลุมเรื่องการบริหารจัดการของชมรม ทั้งส่วนที่เป็นจุดเด่นหรือช่องว่างการดำเนินงาน เช่น การดึงความร่วมมือกับสมาชิก ความต่อเนื่องในการดำเนินงาน ความหลากหลายของกิจกรรมที่จัดให้กับผู้สูงอายุ เป็นต้น',
//     ],
//     value: '',
//   },

//   elderlyInfoText:
//     'สำหรับข้อมูลผู้สูงอายุและข้อมูลด้านสุขภาพ ด้านสังคมและด้านเศรษฐกิจของผู้สูงอายุในหมู่บ้าน {village} ตำบล {subDistrict} อำเภอ {district} จังหวัด {province}  มีรายละเอียด ดังนี้',
//   elderlyCountTypeText: '1.จำนวนและประเภทของผู้สูงอายุในชุมชน',
//   elderlyCountText: 'จำนวนผู้สูงอายุ',
//   allPeople: {
//     name: 'allPeople',
//     label: 'ประชากรทั้งหมดในชุมชน',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     value: '',
//   },
//   elderlyPeople: {
//     name: 'elderlyPeople',
//     label: 'ประชากรผู้สูงอายุ (อายุ 60 ปี ขึ้นไป)',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     value: '',
//   },
//   elderlyTypeText: 'ประเภทของผู้สูงอายุ',
//   elderlySocialGroup: {
//     name: 'elderlySocialGroup',
//     label: 'ผู้สูงอายุที่สามารถดูแลตนเองได้โดยไม่ต้องพึ่งผู้อื่น (กลุ่มติดสังคม)',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     value: '',
//   },
//   elderlyHomeGroup: {
//     name: 'elderlyHomeGroup',
//     label: 'ผู้สูงอายุที่ต้องพึ่งผู้อื่นบ้างในการประกอบกิจวัตรประจำวัน (กลุ่มติดบ้าน)',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     value: '',
//   },
//   elderlyBedStickGroup: {
//     name: 'elderlyBedStickGroup',
//     label: 'ผู้สูงอายุที่ต้องพึ่งพาผู้อื่นทั้งหมด (กลุ่มติดเตียง)',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     value: '',
//   },
//   elderlyTypeSourceInfo: {
//     name: 'elderlyTypeSourceInfo',
//     label: 'แหล่งที่มาของข้อมูล',
//     hint: 'แหล่งที่มา',
//     value: '',
//   },
//   elderlyTypeSourceMonth: {
//     name: 'elderlyTypeSourceMonth',
//     label: 'ข้อมูล ณ เดือน',
//     hint: 'เดือน',
//     value: '',
//   },
//   elderlyTypeSourceInfoYear: {
//     name: 'elderlyTypeSourceYear',
//     label: 'พ.ศ.',
//     hint: 'พ.ศ.',
//     value: '',
//   },

//   elderlyHealthText: '2. ข้อมูลด้านสุขภาพของผู้สูงอายุในชุมชน',
//   elderlyHealth: {
//     name: 'elderlyHealth',
//     label: '2. ข้อมูลด้านสุขภาพของผู้สูงอายุในชุมชน',
//     description: ['ผู้สูงอายุบางคนอาจมีปัญหาสุขภาพได้มากกว่า 1 โรค'],
//   },
//   elderlyNoHealthProblem: {
//     name: 'elderlyNoHealthProblem',
//     label: '1. ผู้สูงอายุที่ไม่มีปัญหาด้านสุขภาพ',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     value: '',
//   },
//   elderlyHealthProblem: {
//     name: 'elderlyHealthProblem',
//     label: '2. ผู้สูงอายุที่มีปัญหาด้านสุขภาพ',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     value: '',
//   },
//   elderlyHypertension: {
//     name: 'elderlyHypertension',
//     label: '2.1 โรคความดันโลหิตสูง',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     value: '',
//   },
//   elderlyDiabetes: {
//     name: 'elderlyDiabetes',
//     label: '2.2 โรคเบาหวาน',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     value: '',
//   },
//   elderlyDegenerative: {
//     name: 'elderlyDegenerative',
//     label: '2.3 โรคข้ออักเสบ ข้อเสื่อม',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     value: '',
//   },
//   elderlyEmphysema: {
//     name: 'elderlyEmphysema',
//     label: '2.4 โรคถุงลมโป่งพอง หลอดลมปิดอุดกั้นเรื้อรัง',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     value: '',
//   },
//   elderlyCoronaryHeartDisease: {
//     name: 'elderlyCoronaryHeartDisease',
//     label: '2.5 โรคหลอดเลือดหัวใจตีบ กล้ามเนื้อหัวใจตาย',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     value: '',
//   },
//   elderlyParalysis: {
//     name: 'elderlyParalysis',
//     label: '2.6 โรคอัมพาต',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     value: '',
//   },
//   elderlyDepression: {
//     name: 'elderlyDepression',
//     label: '2.7 ภาวะซึมเศร้า',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     value: '',
//   },

//   elderlyOtherDisease: {
//     name: 'elderlyOtherDisease',
//     value: [
//       { name: 'XXX', value: 10 },
//       { name: 'YYY', value: 100 },
//     ],
//     diseaseName: {
//       name: 'diseaseName',
//       hint: 'โรค....',
//     },
//     diseaseValue: {
//       name: 'diseaseValue',
//       preLabel: 'จำนวน',
//       postLabel: 'คน',
//     },
//   },

//   elderlyHealthPromotion: {
//     name: 'elderlyHealthProblem',
//     label: '3. ผู้สูงอายุที่มีพฤติกรรมส่งเสริมสุขภาพ',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     value: '',
//   },
//   elderlyHealthExercise: {
//     name: 'elderlyHealthExercise',
//     label: '3.1 ออกกำลังกายเป็นประจำ',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     value: '',
//   },
//   elderlyHealthRightFood: {
//     name: 'elderlyHealthRightFood',
//     label: '3.2 บริโภคอาหารที่เหมาะสม',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     value: '',
//   },
//   elderlyHealthSourceInfo: {
//     name: 'elderlyHealthSourceInfo',
//     label: 'แหล่งที่มาของข้อมูล',
//     hint: 'แหล่งที่มา',
//     value: '',
//   },
//   elderlyHealthSourceMonth: {
//     name: 'elderlyHealthSourceMonth',
//     label: 'ข้อมูล ณ เดือน',
//     hint: 'เดือน',
//     value: '',
//   },
//   elderlyHealthSourceInfoYear: {
//     name: 'elderlyHealthSourceInfoYear',
//     label: 'พ.ศ.',
//     hint: 'พ.ศ.',
//     value: '',
//   },

//   elderlySocialInfoText: '3. ข้อมูลด้านสังคมของผู้สูงอายุในชุมชน',
//   elderlySocialCount: {
//     name: 'elderlySocialCount',
//     label: '1. ประชากรผู้สูงอายุในชุมชน (อายุ 60 ปี ขึ้นไป)',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     value: '',
//   },
//   elderlySocialJoinActivity: {
//     name: 'elderlySocialJoinActivity',
//     label: '2. ผู้สูงอายุที่เข้าร่วมกิจกรรมกลุ่ม/ชมรมผู้สูงอายุ',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     value: '',
//   },
//   elderlySocialAccident: {
//     name: 'elderlySocialAccident',
//     label:
//       '3. ผู้สูงอายุที่มีประสบการณ์ในการหกล้ม เช่น หกล้มจากท่ายืน/ตกจากเตียง เก้าอี้ หรือตกจากที่สูง',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     value: '',
//   },

//   elderlySocialInfoSummaray: {
//     preLabel:
//       'จากข้อมูลในข้อที่ 3 พบว่ามีผู้สูงอายุ ที่เข้าร่วมกิจกรรมกลุ่ม/ชมรมผู้สูงอายุ จำนวน',
//     postLabel: 'คน',
//   },
//   elderlySocialInfoPercent: {
//     preLabel: '(คิดเป็นร้อยละ',
//     postLabel:
//       ') ที่เข้าร่วมกิจกรรมกลุ่ม / ชมรมผู้สูงอายุ โดยผู้สูงอายุส่วนที่เหลือที่ไม่ได้เข้าร่วมกิจกรรมกับกลุ่ม/ชมรมผู้สูงอายุ มีสาเหตุมาจาก',
//   },

//   elderlySocialInfoFooter: {
//     name: 'elderlySocialInfoFooter',
//     value: '',
//   },
//   otherProblems: {
//     name: 'otherProblems',
//     label: 'นอกจากนี้ยังได้พบสถานการณ์ปัญหาอื่นๆ ที่เกี่ยวข้องกับกลุ่มผู้สูงอายุ ได้แก่',
//     description: [
//       'โปรดระบุสาเหตุและปัญหาของผู้สูงอายุและผลกระทบที่เกิดขึ้น โดยละเอียด ไม่ควรบอกเพียงหัวข้อสั้นๆ (กรณีมีหลายข้อให้ทำการขึ้นบรรทัดหรือย่อหน้าใหม่)',
//     ],
//     value: '',
//   },
// }
